import styled from 'styled-components';

import { RounderContainer, withRadius } from '@r1-frontend/ui-react/experimental/containers';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';


export const RoundedStickyBlock = styled(withRadius(
    RounderContainer,
    { $radius: 24 },
))`
    width: 100%;
    position: sticky;
    top: 120px;
    margin-top: 54px;
    padding: 24px;
    height: max-content;

    background-color: ${COLORS.BgSurface};
`;
